module.exports = __webpack_public_path__ + "static/curatorial-projects-thumbnail-747dce64d76110e68b33072f1ba18b81.jpg";